export default "__VITE_ASSET__CUlrWMoQ__"